import { Component, Input, OnChanges } from '@angular/core';
import { FormDetailsComponentData } from '../../form-details.model';
import { SubmissionDetailsParams } from '../../../../submission-details.model';
import { IncompleteFormFacade } from './incomplete-form.facade';
import { SubmissionDetailsActionsService } from '../../../../actions/submission-details-actions.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifbp-incomplete-form',
    templateUrl: './incomplete-form.component.html',
    providers: [IncompleteFormFacade],
    standalone: false
})
export class IncompleteFormComponent implements OnChanges {
  initialData: FormDetailsComponentData;
  isFirstInit: boolean = true;

  @Input()
  params: SubmissionDetailsParams;

  constructor(
    private readonly facade: IncompleteFormFacade,
    private readonly actions: SubmissionDetailsActionsService,
  ) { }

  ngOnChanges(): void {
    this.initData();
  }

  private initData(): void {
    this.facade.getComponentData$(this.params.appId).pipe(untilDestroyed(this))
      .subscribe(data => {
        this.initialData = data;
        if (this.isFirstInit) {
          this.firstInitActions(data);
          this.isFirstInit = false;
        }
      });
  }

  private firstInitActions(data: FormDetailsComponentData): void {
    this.facade.openIncompleteSubmissionDialogIfNeeded(data.application);
    this.actions.markDataAsLoaded(true);
  }
}
